import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule, MatInputModule, MatButtonModule, MatTableModule, MatSelectModule, MatOptionModule, MatIconModule, MatPaginatorModule, MatExpansionModule, MatProgressSpinnerModule, MatCardModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material';

import { AddFundPopupV2Component } from './add-fund-popup-v2/add-fund-popup-v2.component';
import { PaymentSuccessTemplateComponent } from './payment-success-template/payment-success-template.component';
import { PaymentFailureTemplateComponent } from './payment-failure-template/payment-failure-template.component';
import { RouterModule } from '@angular/router';
import { MaterialTableComponent } from './material-table/material-table.component';
import { LoaderModule } from '../directives/loader.module';
import { FlexSwiftAttributeComponent } from './flex-swift-attribute/flex-swift-attribute.component';
import { FlexTooltipComponent} from "../shared/tooltip/flex-tooltip.component";
import { LoanSuggestedTermPopUpComponent } from './loan-suggested-term-pop-up/loan-suggested-term-pop-up.component';
import { WithdrawnSuccessPopUpComponent } from './withdrawn-success-pop-up/withdrawn-success-pop-up.component';
import { LoanSettlementTableComponent } from './loan-settlement-table/loan-settlement-table.component';
import { LoanSettlementNegotiationPopUpComponent } from './loan-settlement-negotiation-pop-up/loan-settlement-negotiation-pop-up.component';
import { LoanSettlementNegotiationAcceptPopUpComponent } from './loan-settlement-negotiation-accept-pop-up/loan-settlement-negotiation-accept-pop-up.component';
import { LoanSettlementNegotiationRejectPopUpComponent } from './loan-settlement-negotiation-reject-pop-up/loan-settlement-negotiation-reject-pop-up.component';
import { InterestRateRiskRangePopupComponent } from './interest-rate-risk-range-popup/interest-rate-risk-range-popup.component';



@NgModule({
  declarations: [
    AddFundPopupV2Component, 
    PaymentSuccessTemplateComponent, 
    PaymentFailureTemplateComponent, 
    MaterialTableComponent, 
    FlexSwiftAttributeComponent,
    FlexTooltipComponent,
    LoanSuggestedTermPopUpComponent,
    WithdrawnSuccessPopUpComponent,
    LoanSettlementTableComponent,
    LoanSettlementNegotiationPopUpComponent,
    LoanSettlementNegotiationAcceptPopUpComponent,
    LoanSettlementNegotiationRejectPopUpComponent,
    InterestRateRiskRangePopupComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule, 
    FormsModule, 
    ReactiveFormsModule, 
    MatInputModule, 
    MatButtonModule,
    RouterModule,
    MatTableModule,
    LoaderModule,
    MatOptionModule,
    MatSelectModule,
    MatIconModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatCardModule
  ],
  exports: [
    AddFundPopupV2Component, 
    PaymentSuccessTemplateComponent, 
    PaymentFailureTemplateComponent, 
    MaterialTableComponent,
    FlexSwiftAttributeComponent,
    FlexTooltipComponent,
    LoanSuggestedTermPopUpComponent,
    WithdrawnSuccessPopUpComponent,
    LoanSettlementTableComponent
  ]
})
export class SharedModule { }
